import { Dispatch, SetStateAction } from 'react'
import { LoanSelectorStateType } from './loan-selector/typings'
import {
  INSTALLMENT_BREAK_MAP,
  PAYOUT_DURATION_MAP,
  UNSCHEDULED_REPAYMENT_MAP,
} from './product-details/sections/typings'

export type BankListResponse = {
  result: Result
  errors: string
  status: number
}

export type Result = {
  banklist?: BankListItem[]
}

export type BankListItem = {
  product: Product
  calculation: Calculation
}

export type Calculation = {
  monthlyRate: Fee
  monthlyRateTwoThird: Fee
  effectiveInterestRate: number
  effectiveInterestRateTwoThird: number
  effectiveInterestRateMax: number
  total: Fee
  totalTwoThird: Fee
  nominalInterestRate: number
  nominalInterestRateTwoThird: number
  nominalInterestRateMax: number
  finalRate: Fee
  specialInterest: boolean
  fee: Fee
  legalText: string
}

export type Fee = {
  euros: number
  cents: number
}

export type Product = {
  id: number
  name: string
  bank: Bank
  recommendationRate: number
  images: Images
  conditions: Conditions
  features: Features
}

export type Bank = {
  id: number
  code: string
  name: string
  address: string
}

export type Conditions = {
  processingFee: boolean
  unscheduledPartialRepayment: keyof typeof UNSCHEDULED_REPAYMENT_MAP
  unscheduledTotalRepayment: keyof typeof UNSCHEDULED_REPAYMENT_MAP
  installmentBreak: keyof typeof INSTALLMENT_BREAK_MAP
}

export type Features = {
  videoIdent: boolean
  documentUpload: boolean
  onlineSignature: boolean
  payoutDuration: keyof typeof PAYOUT_DURATION_MAP
}

export type Images = {
  colorSVG: string
  graySVG: string
}

export type Term = {
  termMax: number
  termMin: number
}

export type IBankListPage = {
  paapiUrl: string
  defaultBankList: BankListItem[]
}

export enum RATE_AFFIX {
  PREFIX,
  SUFFIX,
}

export type Decorator = {
  affix: RATE_AFFIX
  value: string
}

export interface ISpecialInterestRateTooltip {
  toolTipCls: string
  spanCls: string
}

export interface IBankListComponentProps {
  bankList: BankListItem[]
}

export interface IBankListItemProps {
  bankListItem: BankListItem
  isRowExpanded: boolean
  expandHandler: (panel: string) => void
}

export type SetState = Dispatch<
  SetStateAction<{
    [x: string]: boolean
  }>
>
export interface IBankCTAButtonProps {
  productId: string
  expandHandler: (panel: string) => void
  isRowExpanded: boolean
}

export type PrefillPayload = {
  purpose: string
  amount: number
  term: number
  termsAccepted: boolean
  dataProcessingConsentGiven: boolean
  advertisementId: string
  resumeHash?: string
}

export type PrefillResponse = {
  result: PrefillResult
  errors: string
  status: number
}

export type PrefillResult = {
  url: string
  resumeHash: string
}

export interface IBankList {
  bankList: BankListItem[]
}

export type BankListContextType = {
  loanSelectorState: LoanSelectorStateType
  handleCTAButtonClick?: (
    func: SetState,
    productId: string,
    currentLoanSelectorState: LoanSelectorStateType,
  ) => Promise<void>
  handleLoanSelectorValueChange?: (lsState: LoanSelectorStateType) => void
}
